import { baseMutations, baseActions } from '../functions'

export default {
  namespaced: true,
  state: {
    // Info
    items: [],
    title: 'Estatísticas',
    name: 'Estatísticas',
    loading: true,

    // Menu
    menu: {
      title: 'Estatísticas',
      icon: { key: 'chart', custom: true }
    },

    // Routes - Components actions
    actions: {
      // Main Action
      component: 'Cards.Estatisticas'
    }
  },
  mutations: Object.assign({}, baseMutations, {
    // ...
  }),
  actions: Object.assign({}, baseActions, {
    // ...
  })
}
